import React from "react";

export default function RoamingInternationalratesShimmer() {
  const styles = {
    FlagImage: {
      width: "80px",
      height: "53px",
    },
    padding15: {
      margin: "15px",
    },
    toggelButton: {
      width: "50px",
      height: "30px",
      borderRadius: "30px",
    },
    width15: {
      width: "15%",
    },
    height36: {
      height: "36px",
    },
    width10: {
      width: "10%",
    },
    bottomBannerImage: {
      width: "448px",
      height: "256px",
    },
  };
  return (
    <div style={{ background: "rgb(240, 240, 240)" }}>
      <div className="shimmer-effect">
        <div
          class="sprint14_banner_bg"
          style={{ background: "rgb(223, 223, 225)" }}
        >
          <div class=" main_banner_comb1 pse_sm w-100">
            <div class="main_banner_text">
              <h4 class="mb-0 h3_title_restrct shimmerBG shimmer-h30 m-0 w-100"></h4>
            </div>
            <div class="main_banner_img">
              <div class="banner-country-logo sprint14-bg-transparent">
                <div
                  alt=""
                  title=""
                  class="borderradius5 shimmerBG"
                  style={styles.FlagImage}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* // */}

      <div class="minus_pse_sm">
        <ul
          class="line_tabs white_bg sprint14_roaming_tabs nav nav-tabs"
          tabclassname="demo"
          role="tablist"
        >
          <div
            className="  w-50 text-center d-flex justify-content-center "
            style={styles.padding15}
          >
            <div className="shimmerBG  m-0 w-60 "> </div>
          </div>
          <div
            className="w-50 text-center d-flex justify-content-center "
            style={styles.padding15}
          >
            <div className="shimmerBG  m-0 w-60 "> </div>
          </div>
        </ul>
        <div class="tab-content ">
          <div
            role="tabpanel"
            id="uncontrolled-tab-example-tabpane-roaming-rates"
            aria-labelledby="uncontrolled-tab-example-tab-roaming-rates"
            class="fade tab-pane active show"
          >
            <div class="pse_sm pt-4 pb-4">
              <div>
                <div class="icon_img_desc_style">
                  <div class="desc_grp">
                    <div class="primary_20 mb-0 rubik-semiBold shimmerBG shimmer-h25 w-50"></div>
                  </div>
                  <div class="action_grp">
                    <div class="shimmerBG m-0" style={styles.toggelButton}>
                      <label for="test6">&nbsp;</label>
                    </div>
                  </div>
                </div>

                <div class="support_text mt-3 primary1_16 notoSans-light shimmerBG shimmer-h15 "></div>
                <div class="support_text primary1_16 notoSans-light shimmerBG shimmer-h15 "></div>
                <div class="support_text primary1_16 notoSans-light shimmerBG shimmer-h15 "></div>
                <div class="support_text mb-3 primary1_16 notoSans-light shimmerBG shimmer-h15 "></div>
              </div>
              <hr class="hr_line" />
              <div class="icon_img_desc_style">
                <div class="desc_grp">
                  <h4 class="primary_12 mb-0 rubik-semiBold shimmerBG shimmer-h15 m-0 w-50"></h4>
                  <p class="primary_13 support_text mt-3 mb-0 notoSans-light shimmerBG shimmer-h15 w-50"></p>
                  <p class="primary_13 mt-3 mb-0 primary_color rubik-semiBold shimmerBG  w-100"></p>
                </div>
              </div>
              <hr class="hr_line" />

              <div class="mb-4">
                <div class="white-bg sprint14-roaming-charges borderradius15">
                  <div class="roamingpackrow">
                    <div class="roaming-pack-row">
                      <div class="roaming-sub-left shimmerBG  m-0 w-50 mb-2">
                        {" "}
                      </div>
                      <div class="roaming-sub-right w-50 d-flex justify-content-end w-100">
                        {" "}
                        <label class="dir-ltrl shimmerBG shimmer-h25 m-0 mb-2 w-50"></label>
                      </div>
                    </div>
                    <hr />
                    <div class="roaming-pack-row pb-2 w-100">
                      <div
                        class="roaming-sub-left shimmerBG "
                        style={styles.width15}
                      >
                        {" "}
                      </div>
                    </div>
                    {[1, 2, 3, 4].map((item) => (
                      <div class="roaming-pack-row" style={styles.height36}>
                        <div class="roaming-pack-text shimmerBG w-50 m-0 shimmer-h15">
                          {" "}
                        </div>
                        <label class="dir-ltrl shimmer-h20 shimmerBG w-50 m-0 shimmer-h15">
                          {" "}
                        </label>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <div class="roamingpackrow">
                    <div class="roaming-pack-row pb-2">
                      <div
                        class="roaming-sub-left shimmerBG w-10 "
                        style={styles.width10}
                      >
                        {" "}
                      </div>
                    </div>
                    {[1, 2].map((item) => (
                      <div class="roaming-pack-row" style={styles.height36}>
                        <div class="roaming-pack-text shimmerBG w-50 m-0 shimmer-h15">
                          {" "}
                        </div>
                        <label
                          class="dir-ltrl shimmer-h15 shimmerBG w-50 m-0 shimmer-h15"
                          style={styles.height17}
                        >
                          {" "}
                        </label>
                      </div>
                    ))}
                  </div>
                  <hr />
                  <div class="roaming-noraml-text shimmerBG w-100"></div>
                  <div class="roaming-noraml-text shimmerBG w-50"></div>
                </div>
              </div>
            </div>
            <section class="mt-5">
              <div class="sprint14-offer-comp w-100">
                <div
                  class="shimmerBG w-50 shimmer-h25 "
                  style={{ margin: "0px auto 0px" }}
                ></div>
                <div className="w-100">
                  <div
                    class="w-100 might-you-like-comp mt-4 "
                    style={{ position: "inherit" }}
                  >
                    <div
                      // src="/webapis/api/Banner/Getimageweb?id=24299&amp;l=en"
                      alt=""
                      title=""
                      style={styles.bottomBannerImage}
                      class="w-100 shimmerBG"
                    ></div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
